import { Injectable } from '@angular/core';
import { AWSAppSyncClient } from 'aws-appsync';
import { AUTH_TYPE } from 'aws-appsync';
import { environment } from '../../environments/environment';
import { ItonicsAuthService } from './itonicsAuth.service';

@Injectable()
export class AppsyncService {
  client: AWSAppSyncClient;

  constructor(private itonicsAuthService: ItonicsAuthService) {
    this.client = new AWSAppSyncClient({
      url: environment.appSync.graphqlEndpoint,
      region: environment.appSync.region,
      auth: {
        type: AUTH_TYPE[environment.appSync.authenticationType],
        jwtToken: itonicsAuthService.idToken
      },
      disableOffline: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/appsync.service.ts